<div>

	<div class="dashboard-container upload">

		<h2>{{ 'STATISTICS' | translate }}</h2>

		<bb-adstats-blocks [statsDate]="statsDate"></bb-adstats-blocks>

		<h2>{{ 'RECENTLY_CREATED_AD_UNITS' | translate }}</h2>

		<bb-table-container>

			<bb-table-header>
				<bb-table-header-cell [hideSorting]="true" property="id">{{ 'ID' | translate }}</bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="positionType">{{ 'FORMAT' | translate }}</bb-table-header-cell>
				<bb-table-header-cell class="date" [hideSorting]="true" property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
				<bb-table-header-cell [hideSorting]="true" property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			</bb-table-header>

			<bb-table-row *ngFor="let row of rows" [row]="row">
				<bb-table-cell class="length" property="id"><span [innerHTML]="row.data.id"></span></bb-table-cell>
				<bb-table-cell class="type" property="positionType"><span [attr.title]="row.data.positionType" [innerHTML]="row.data.positionType"></span></bb-table-cell>
				<bb-table-cell class="date" property="createddate"><span [innerHTML]="row.data.createddate | bbDate:'relative'"></span></bb-table-cell>
				<bb-table-cell property="title" class="overflow"><span [attr.title]="row.data.title" [innerHTML]="row.data.title"></span></bb-table-cell>
			</bb-table-row>

		</bb-table-container>

		<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_AD_UNITS_FOUND' | translate }}</div>

		<a class="button" [routerLink]="['/adservices/adunits']">
			<span>{{ 'VIEW_ALL_AD_UNITS' | translate }}</span>
		</a>

	</div>

</div>
